import { ReplaysModalComponent } from "./../replays-modal/replays-modal.component";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material";
import { FiltersModalComponent } from "../filters-modal/filters-modal.component";
import { UserModalComponent } from "../user-modal/user-modal.component";
import { UserProfileModalComponent } from "../user-profile-modal/user-profile-modal.component";
import { PictogramModalComponent } from "../pictogram-modal/pictogram-modal.component";
import { CropperPictureModalComponent } from "../cropper-picture-modal/cropper-picture-modal.component";
import { MagicBoxRuleFormComponent } from "../magic-box-rule-form/magic-box-rule-form.component";
import { MagicBoxScheduleComponent } from "../magic-box-schedule/magic-box-schedule.component";
import { MultilingualModalComponent } from "../multilingual-modal/multilingual-modal.component";
import { TranslateClassificationModalComponent } from "../translate-classification-modal/translate-classification-modal.component";
import { MulticamsModalComponent } from "../multicams-modal/multicams-modal.component";
import { AdditionalPicturesModalComponent } from "../additional-pictures-modal/additional-pictures-modal.component";
import { EventAdditionalPicturesModalComponent } from "../event-additional-pictures-modal/event-additional-pictures-modal.component";
import { MaxMultilingualModalComponent } from "../max-multilingual-modal/max-multilingual-modal.component";
import { EventMaxMultilingualModalComponent } from "../event-max-multilingual-modal/event-max-multilingual-modal.component";

@Component({
  selector: "app-root-modal",
  templateUrl: "./root-modal.component.html",
  styleUrls: ["./root-modal.component.scss"],
})
export class RootModalComponent implements OnInit {
  private dialogRef: MatDialogRef<any>;

  /**
   * Add dependencies
   * @param {MdDialog} dialog
   * @param {Router} router
   * @param {ActivatedRoute} activatedRoute
   */
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  /**
   * Open modal according to the type and the action parameters
   */
  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      switch (params.type) {
        case "filters":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(FiltersModalComponent);
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;
        case "user":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(UserModalComponent, {
              data: { id: params.id },
            });
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;
        case "picture":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(CropperPictureModalComponent, {
              data: {
                id: params.id,
                optional: params.optional,
                optional2: params.optional2,
                type: params.optional3,
              },
            });
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;
        case "pictogram":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(PictogramModalComponent, {
              data: {
                id: params.id,
                optional: params.optional,
                optional2: params.optional2,
                type: params.optional3,
              },
            });
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;
        case "user-profile":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(UserProfileModalComponent, {
              data: { id: params.id },
            });
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;
        case "rule":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(MagicBoxRuleFormComponent, {
              data: {
                id: params.id,
                optional: params.optional,
                optional2: params.optional2,
              },
            });
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;
        case "schedule":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(MagicBoxScheduleComponent);
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;
        case "multilingual":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(MultilingualModalComponent, {
              data: {
                valEmiId: params.id,
                destination: params.optional,
                channelId: params.optional2,
              },
            });
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;

        case "multilingual-event-article":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(MultilingualModalComponent, {
              data: {
                sportingEventId: params.id,
              },
            });
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;
        case "replays":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(ReplaysModalComponent, {
              data: {
                spevId: params.spevId,
                contentId: params.contentId,
                languageId: params.languageId,
                destination: params.destination,
                productCode: params.productCode,
                programId: params.programId,
              },
            });
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;
        case "multicams":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(MulticamsModalComponent, {
              data: {
                spevId: params.spevId,
                languageId: params.languageId,
                destination: params.destination,
              },
            });
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;
        case "additional":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(
              AdditionalPicturesModalComponent,
              {
                data: {
                  validatedEmissionId: params.validatedEmissionId,
                  channelId: params.channelId,
                  languageId: params.languageId,
                  destinationName: params.destinationName,
                },
              }
            );
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;
        case "event-additional":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(
              EventAdditionalPicturesModalComponent,
              {
                data: {
                  sportingEventId: params.sportingEventId,
                  languageId: params.languageId,
                },
              }
            );
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;
        case "translate-classification":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(
              TranslateClassificationModalComponent,
              { data: { id: params.id, key: params.key } }
            );
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;

        case "max-multilingual":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(MaxMultilingualModalComponent);
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;

        case "event-max-multilingual":
          setTimeout(() => {
            this.dialogRef = this.dialog.open(EventMaxMultilingualModalComponent);
            this.dialogRef.afterClosed().subscribe(() => {
              this.router.navigate([{ outlets: { modal: null } }]);
            });
          });
          break;

        default:
          this.router.navigate([{ outlets: { modal: null } }]);
          break;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/root-modal/root-modal.component.ts